export default __webpack_public_path__ + "static/media/icon-imprimante.7fbf2442.svg";